import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../../QueryKey'
import {getLandingPopup} from '../../../../apis/landing/popup/list'
import {TypeSlot} from '../../../../apis/promotion/create'

const useQueryGetLandingPopups = (slot?: TypeSlot) => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.landing.getPopups(),
        queryFn: async () => {
            const {data} = await getLandingPopup(slot)
            return data
        },
        refetchOnWindowFocus: false,
    })

    return {data, refetch}
}

export default useQueryGetLandingPopups
